import React, { useEffect } from "react";
import { createPortal } from "react-dom";

import { useRequisitesStyles } from "./useRequisitesStyles";

type ModalState = "requisites" | "basket" | "productForm" | "";

interface IModalUIProps {
  isOpen: boolean;
  handleClose: (arg: ModalState) => () => void;
  className?: string;
}

const Requsites = ({ isOpen, className = "", handleClose }: IModalUIProps) => {
  const onKey = (e: KeyboardEvent) => {
    if (e.key === "Escape") {
      handleClose("")();
    }
  };

  const onClickOverlay = (e: React.MouseEvent<HTMLElement>) => {
    handleClose("");

    if ((e.target as HTMLElement).classList.contains("req")) {
      handleClose("")();
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflowY = "hidden";
      window.addEventListener("keydown", onKey);
    } else {
      document.body.style.overflowY = "scroll";
      window.removeEventListener("keydown", onKey);
    }
    return () => {
      window.removeEventListener("keydown", onKey);
    };
  }, [isOpen]);

  return isOpen ? (
    <>
      <ModalContainerSC onClick={onClickOverlay} className={className}>
        <ContainerSC>
          <ReplyIconSC onClick={handleClose("")} src="ReplyIcon.svg" />
          <TextSC>
            <p>ИП Артёмова Ксения Андреевна</p>
            <p>Телефон: +7 (912) 403-16-66</p>
            <p>Режим работы: Понедельник-Пятница, с 9:00 до 17:00</p>
            <p>
              Наши склады: г. Челябинск, ш. Копейское, д.56, строение 1; г.
              Челябинск, тракт Троицкий, д. 52Б
            </p>
            <p>Email: artmova.ksenya@mail.ru</p>
            <p>ИНН: 743006085219</p>
            <p>ОГРНИП: 321745600060637</p>
          </TextSC>
          <TitleSC>Политика возврата</TitleSC>
          <TextSC>
            <b>
              <i>Отказ от заказа и возврат товара</i>
            </b>
            <br />
            <br />
            <p>
              — Отказ от заказа до момента его получения Вы можете отказаться от
              заказа заполнив форму обратной связи, или обратившись по телефону:
              +7 (912) 403-16-66.
            </p>
            <br />{" "}
            <p>
              — Возврат товара ненадлежащего качества Вы можете вернуть товар
              ненадлежащего качества по адресам, указанным выше. Необходимо
              предъявить товар в ненарушенной оригинальной упаковке
              производителя (в том числе должна быть не нарушена упаковка,
              сохранены товарный вид и потребительские свойства).
            </p>{" "}
            <br />
            <p>
              — Возврат товара ненадлежащего качества при обнаружении недостатка
              (несоответствия требованиям к качеству) товара Вы можете в течение
              14 календарных дней обратиться по телефону: +7 (912) 403-16-66.
            </p>{" "}
            <br />
            <p>
              При оформлении возврата любого товара Вам необходимо предъявить
              следующие документы: фискальный чек или счет-фактуру.
            </p>{" "}
            <br />
            <b>
              <i>Возврат денежных средств</i>
            </b>{" "}
            <br /> <br />
            <p>
              — Отказ от товара до получения если Вы отказались от заказа до
              момента получения, предварительно оплатив его банковской картой на
              сайте, денежные средства будут возвращены в течение 10 рабочих
              дней на банковскую карту, с которой был оплачен заказ.
            </p>{" "}
            <br />
            <p>
              — Отказ от товара после получения в случае оплаты заказа
              наличными, денежные средства будут возвращены Вам непосредственно
              при оформлении возврата. При оплате банковской картой возврат
              денежных средств осуществляется в течение 10 рабочих дней на
              банковскую карту, с которой был оплачен заказ.
            </p>{" "}
            <br />
            <p>
              — Возврат денежных средств при типе оплаты «Банковский перевод» 1.
              В случае если Ваш заказ предоплачен, и Вы желаете отказаться от
              товара, либо обнаружили фактическое отсутствие товара в
              поставленном заказе в момент самовывоза, Вам следует указать в
              графе товарной накладной «Товар» позиции, от принятия которых Вы
              отказываетесь/ фактически отсутствуют: количество, сумма, код
              причины отказа. Во всех экземплярах товарной накладной указать,
              каким образом удобнее получить возврат денежных средств: в счет
              платежа по следующему заказу или переводом на расчетный счет (не
              дожидаясь размещения следующего заказа).
              <br /> <br /> 2. Направить письмо по электронной почте в адрес
              поддержки сайта artmova.ksenya@mail.ru с пожеланием о возврате
              денежных средств на расчетный счет. Денежные средства будут
              возвращены на расчетный счет в течение 10 рабочих дней с момента
              получения соответствующего письма по электронной почте.
            </p>
          </TextSC>
          <TitleSC>Условия доставки товаров</TitleSC>
          <TextSC>
            Доставка товаров и грузов осуществляется Почтой России, CDEK, а
            также самовывоз со склада. Доставка за счет средств покупателя.
          </TextSC>
          <TitleSC>Инструкция по оплате банковской картой на сайте</TitleSC>
          <TextSC>
            <p>
              Для онлайн оплаты на сайте принимаются банковские карты: Visa,
              MasterCard, МИР. Прием платежей на сайте обеспечивает
              процессинговый центр{" "}
              <a
                style={{ textDecoration: "underline" }}
                href="https://paykeeper.ru/">
                PayKeeper
              </a>
              . Для оплаты товара банковской картой при оформлении заказа
              выберете способ оплаты: банковской картой. Обработка платежа
              происходит на авторизованной странице банка, где Вам необходимо
              ввести данные Вашей банковской карты:
            </p>{" "}
            <p>1. Номер карты</p>
            <p>2. Срок действия карты</p>
            <p>
              Имя и фамилию владельца карты (латинскими буквами, как указано на
              карте)
            </p>
            <p>
              Код CVV2/CVC2 (Если на вашей карте код CVC / CVV отсутствует, то,
              возможно, карта не пригодна для CNP транзакций (т.е. таких
              транзакций, при которых сама карта не присутствует, а используются
              её реквизиты), и вам следует обратиться в банк для получения
              подробной информации.)
            </p>
            <br />
            <br />
            <img
              style={{ width: "100%" }}
              src="reqCard.jpg"
              alt=" Подсказка по оплате."
            />
            <br />
            <br />
            <p>
              Если Ваша карта подключена к услуге 3D-Secure (технология
              безопасного проведения интернет-платежей), Вы будите автоматически
              переадресованы на страницу банка, выпустившего карту, для
              прохождения процедуру аутентификации. Информацию о правилах и
              методах дополнительной идентификации уточняйте в банке, выдавшем
              Вам банковскую карту. <br /> <br />
              Безопасность обработки интернет-платежей через платежный шлюз
              банка гарантирована международным сертификатом безопасности PCI
              DSS. Передача информации происходит с применением технологии
              шифрования SSL. Эта информация не доступна посторонним лицам.
            </p>
          </TextSC>
          <TitleSC>Политика конфиденциальности</TitleSC>
          <TextSC>
            <p>
              Настоящая Политика определяет порядок, условия обработки
              персональных данных пользователей Интернет-сайта
              https://zapchasti-174.ru/ (далее - Сайт) и устанавливает
              требования по обеспечению безопасности персональных данных
              пользователей Администрацией Сайта.
            </p>
            <br />
            <p>
              Политика разработана и реализуется в соответствии c действующим
              национальным законодательством в сфере персональных данных.
            </p>
            <br />
            <b>
              <i>Определения</i>
            </b>
            <br />
            <br />
            <p>
              Персональные данные – любая информация, относящаяся к прямо или
              косвенно определенному или определяемому физическому лицу
              (гражданину). К такой информации, могут относиться: Ф.И.О., год,
              месяц, дата и место рождения, почтовый адрес, адрес электронной
              почты, номер телефона, сведения о семейном, социальном,
              имущественном положении, сведения об образовании, профессии,
              доходах, сведения о состоянии здоровья, а также другая информация.
            </p>
            <br />
            <p>
              Обработка персональных данных – любое действие с персональными
              данными, совершаемое с использованием средств автоматизации или
              без использования таких средств. К таким действиям могут
              относиться: сбор, получение, запись, систематизация, накопление,
              хранение, обновление, изменение, извлечение, использование,
              передача (распространение, предоставление, доступ), обезличивание,
              блокирование, удаление, уничтожение персональных данных.
            </p>
            <br />
            <p>
              Пользователь – физическое лицо, получающее доступ к функционалу
              Сайта.
            </p>
            <br />
            <p>
              Администрация Сайта – ИП Артёмова К.А. Адрес: 456688, обл.
              Челябинская р-н Красноармейский п. Лесной ул. Степная д. 11
            </p>
            <br />
            <p>
              <b>
                1. Обработка персональных данных пользователей Сайта
                производится с соблюдением следующих принципов:
              </b>
              <br />• законности;
              <br />• ограничения обработки персональных данных достижением
              конкретных, заранее определенных и законных целей;
              <br />• недопущения обработки персональных данных, несовместимой с
              целями сбора персональных данных;
              <br />• недопущения объединения баз данных, содержащих
              персональные данные, обработка которых осуществляется в целях,
              несовместимых между собой.
            </p>
            <br />
            <p>
              <b>2.</b> В процессе обработки персональных данных пользователей
              со стороны Администрации Сайта предпринимаются необходимые и
              достаточные правовые, организационные и технические меры для
              защиты персональных данных от неправомерного или случайного
              доступа к ним, уничтожения, изменения, блокирования, копирования,
              предоставления, распространения персональных данных, а также от
              иных неправомерных действий в отношении персональных данных.
            </p>
            <br />
            <p>
              <b>3.</b> При обработке персональных данных пользователей
              используются технические средства и технологические решения,
              направленные на обезличивание субъектов персональных данных при
              доступе к содержащей персональные данные информации лиц,
              непосредственно задействованных в процессе обработки персональных
              данных.
            </p>
            <br />
            <p>
              <b>4.</b> Персональные данные пользователей хранятся на
              собственных серверах Компании в полном соответствии с правовыми и
              нормативно-техническими требованиями, установленными действующим
              законодательством.
            </p>
            <br />
            <p>
              <b>5.</b> Администрация Сайта не осуществляет обработку
              биометрических и специальных категорий персональных данных
              пользователей.
            </p>
            <br />
            <p>
              <b>6.</b> При изменении своих персональных данных пользователь
              соглашается, что такое изменение происходит на тех же условиях,
              что и первоначальное предоставление им своих персональных данных,
              не требует оформления дополнительного согласия, и измененные
              персональные данные обрабатываются в том же порядке, что и
              первоначально предоставленные персональные данные.
            </p>
            <br />
            <p>
              <b>7.</b> Администрация Сайта гарантирует и обеспечивает полную
              конфиденциальность персональных данных пользователей,
              обрабатываемых при предоставлении доступа к функционалу Сайта, за
              исключением случаев, прямо предусмотренных настоящей Политикой или
              действующим законодательством.
            </p>
            <br />
            <p>
              <b>
                8. Администрация Сайта осуществляет обработку только тех
                персональных данных, которые необходимы для доставки товаров
                пользователю, оказания услуг пользователю, а также для
                надлежащего исполнения договоров, заключаемых с пользователями:
              </b>
              <br />• Фамилия, имя, отчество (при наличии) — для целей
              идентификации пользователя при заключении договора купли-продажи.
              <br />• Телефонный номер — для цели осуществления оперативной
              связи с пользователем по вопросам, связанным с обработкой заказов,
              доставкой товаров, приобретённых пользователем Сайте,
              информированием по вопросам работы Сайта.
              <br />• Адрес электронной почты — для целей направления
              пользователю чеков и иных документов и информации, связанных с
              приобретением товаров на Сайте и необходимых для подтверждения
              факта заключения договора купли-продажи и получения приобретённых
              товаров в пунктах выдачи заказов службы доставки, а также для цели
              осуществления информационных, новостных и рекламных рассылок в
              адрес пользователя.
              <br />• Почтовый адрес – только в случаях доставки пользователям
              товаров, приобретённых ими на Сайте.
            </p>
            <br />
            <p>
              <b>9.</b> Осуществление информационных, новостных и рекламных
              рассылок в адрес пользователя производится Администрацией Сайта
              только в том случае, если имеется согласие пользователя на
              получение таких рассылок. Пользователь в любой момент может
              отказаться от любых рассылок, на которые он был подписан или иным
              образом давал свое согласие.
            </p>
            <br />
            <p>
              <b>
                10. Администрация Сайта вправе передавать персональные данные
                пользователей третьим лицам в следующих случаях:
              </b>
              <br />
              1. Пользователь явно выразил свое согласие на такие действия.
              <br />
              2. Передача необходима для исполнения договора, заключенного с
              пользователем.
              <br />
              3. Передача предусмотрена действующим законодательством.
            </p>
            <br />
            <p>
              <b>11.</b> Пользователь имеет право в любой момент потребовать от
              Администрации Сайта прекращения обработки его персональных данных.
            </p>
            <br />
            <p>
              <b>12.</b> Для целей статистической обработки информации,
              оптимизации и дальнейшего развития функционала Сайта создаются и
              используются файлы «cookie», фиксируются сведения о сетевых
              адресах, с которых пользователями производится регистрация и
              авторизация на Сайте, а также может сохраняться информация о
              действиях пользователей, совершаемых ими в процессе использования
              функционала Сайта, в том числе с помощью специализированных
              программных средств (Яндекс.Метрика, VK Реклама).
            </p>
            <br />
            <p>
              <b>13.</b> Персональные данные пользователей обрабатываются в
              течение 5 лет с момента заключения последнего договора с
              пользователем для целей осуществления бухгалтерского и налогового
              учета в соответствии со ст. 23 Налогового кодекса Российской
              Федерации, ст. 29 Федерального Закона «О бухгалтерском учете» №
              402-ФЗ.
            </p>
            <br />
            <p>
              <b>14.</b> По окончании срока обработки, в том числе по требованию
              пользователя, персональные данные пользователей удаляются из
              информационных систем Администрации Сайта.
            </p>
          </TextSC>
          <TitleSC>Договор оферты</TitleSC>
          <TextSC>
            <p>
              <b>Публичная оферта о заключении договора оказания услуг.</b>
            </p>
            <br />
            <p>
              Настоящий документ является предложением ИП «Мишарин Эдуард
              Валерьевич» (далее – «Компания») в адрес зарегистрированных и
              незарегистрированных пользователей (далее – «пользователи», «вы»)
              сайта, расположенного на домене https://zapchasti-174.ru/ и всех
              его поддоменах (далее – «zapchasti-174.ru») заключить рамочный
              договор оказания услуг (далее – «Договор») на указанных ниже
              условиях (далее – «Оферта»).
            </p>
            <br />
            <p>
              Термины и определения, применяемые в настоящем Договоре термины и
              определения используются в следующем их значении:
            </p>
            <br />
            <p>
              «Сайт» одна или несколько логически связанных между собой
              веб-страниц, объединенных общей тематикой, расположенный под одним
              адресом, доступный пользователем с помощью интернет
            </p>
            <br />
            <p>
              «Товары/Услуги» ассортимент продукции или услуг, размещенный на
              сайте zapchasti-174.ru, предназначенный для реализации для
              физическим или юридическим лицам путем оформления заказа онлайн
            </p>
            <br />
            <b>
              <i>1. Предмет Договора</i>
            </b>
            <br />
            <br />
            <p>
              <b>1.1.</b> Договор определяет общие условия обязательственных
              отношений, возникающих между Компанией и Пользователем при
              оказании Компанией реализации товаров с помощью сайта
              zapchasti-174.ru
            </p>
            <br />
            <p>
              <b>1.2.</b> Заключаемый Договор представляет собой договор с
              открытыми условиями. Существенные условия каждой совершаемой на
              zapchasti-174.ru сделки по оказанию Услуг формируются онлайн с
              помощью интерфейса zapchasti-174.ru, посредством которого
              Пользователь выбирает интересующий его товар.
            </p>
            <br />
            <b>
              <i>2. Заключение Договора. Заказ Услуг</i>
            </b>
            <br />
            <br />
            <p>
              <b>2.1.</b> Оферта считается акцептованной Пользователем, а
              Договор между Компанией и Пользователем, заключенным с момента
              оплаты пользователем товара по соответствующей сделке (в этом
              случае она совершается одновременно с заключением Договора) или с
              момента внесения аванса в счет оплаты заказываемых в будущем
              товаров. Условия заключенного Договора применяются ко всем
              последующим сделкам между Пользователем и Компанией. Договор может
              быть заключен только с Пользователем, являющимся дееспособным
              физическим лицом либо юридическим лицом или индивидуальным
              предпринимателем.
            </p>
            <br />
            <p>
              <b>2.2.</b> Каждый заказ конкретных товаров в рамках Договора
              является самостоятельной сделкой. Сделка во исполнение настоящего
              Договора может быть заключена в отношении товаров, доступных для
              заказа и оплаты на в режиме онлайн.
            </p>
            <br />
            <p>
              <b>2.3.</b> Оплата заказа признается акцептом Пользователя
              предложения о заключении сделки на согласованных сторонами
              условиях.
            </p>
            <br />
            <p>
              <b>2.4.</b> Пользователь оформляет каждый заказ товаров в
              соответствии с условиями действующей редакции Оферты и условиями
              соответствующего сервиса. Условия всех сервисов, опубликованные на
              в момент заказа товаров, являются неотъемлемой частью оферты.
            </p>
            <br />
            <p>
              <b>2.5.</b> Совершая акцепт Оферты, Пользователь выражает согласие
              с тем, что факт выполнения определенных действий на, в том числе с
              использованием профессиональных технических инструментов,
              выполнение команд через интерфейс (нажатие кнопок, клики по
              ссылкам), совершение платежа и иные подобные действия означают
              ваше волеизъявление в отношении заказа товаров в соответствии с
              указанными на параметрами товаров и их ценой.
            </p>
            <br />
            <b>
              <i>3. Общие условия оказания Услуг</i>
            </b>
            <br />
            <br />
            <p>
              <b>3.1.</b> Услуги оказываются на территории Российской Федерации.
            </p>
            <br />
            <p>
              <b>3.2.</b> При оплате заказа банковской картой обработка платежа
              происходит на защищенной странице процессинговой системы, которая
              прошла международную сертификацию. Это значит, что
              конфиденциальные данные Пользователя (реквизиты карты,
              регистрационные данные и др.) не поступают в Компанию, их
              обработка полностью защищена, и никто не может получить
              персональные и банковские данные Пользователя.
            </p>
            <br />
            <p>
              <b>3.3.</b> Предоставляемые на товары могут изменяться,
              дополняться, обновляться, в связи с чем их использование
              предлагается в режиме «как есть», то есть в том виде и объеме, в
              каком они предоставляются Компанией в момент обращения
              Пользователя к услугам и сервисам.
            </p>
            <br />
            <p>
              <b>3.4.</b> Компания вправе направлять Пользователю по имеющимся у
              нее контактным данным уведомления, связанные с исполнением
              настоящего Договора или любой из заключенных в рамках Договора
              сделок, включая оповещения о статусе оказания Услуги, способах
              продления, изменениях условий оказания Услуг и иные информационные
              сообщения, посредством смс- и push-сообщений, электронной почты,
              звонков и сообщений в мессенджерах и телефонных звонков.
            </p>
            <br />
            <p>
              <b>3.5.</b> Пользователь обязуется соблюдать при пользовании
              услугами требования действующего законодательства Российской
              Федерации, положения Договора, соответствующие условия выбранной
              Услуги или сервиса и все иные правила.
            </p>
            <br />
            <p>
              <b>3.6.</b> По требованию Компании Пользователь обязан
              предоставить информацию и документы, необходимые для идентификации
              пользователя в качестве стороны Договора, в частности при
              направлении в адрес Компании заявлений, запросов и прочих
              обращений, связанных с оказанием Услуг на. В целях идентификации
              частных пользователей Компанией могут быть запрошены ФИО, серия и
              номер паспорта, скан-копия второй и третьей страницы паспорта
              (второй разворот), адрес электронной почты и номер телефона
              пользователя, используемые для доступа к профилю. Кроме того,
              Компания вправе самостоятельно проводить верификацию Пользователя
              в качестве стороны по Договору путем проведения сверки указанных
              Пользователем в профиле реквизитов с реквизитами плательщика по
              Договору, а также иными способами.
            </p>
            <br />
            <p>
              <b>3.7.</b> Компания, является оператором персональных данных,
              осуществляет обработку персональных данных Пользователя с целью
              исполнения договора согласно Политике конфиденциальности,
              размещенной на сайте.
            </p>
            <br />
            <b>
              <i>4. Стоймость и оплата товаров</i>
            </b>
            <br />
            <br />
            <p>
              <b>4.1.</b> Стоимость выбранных товаров в российских рублях
              отображается в интерфейсе при оформлении или оплате заказа, если
              иное не предусмотрено условиями соответствующего сервиса или
              Услуги.
            </p>
            <br />
            <p>
              <b>4.2.</b> Стоимость включает НДС 20%, уплачиваемый на территории
              РФ.
            </p>
            <br />
            <p>
              <b>4.3.</b> Оплата товаров осуществляется на условиях предоплаты
              по ценам, действующим на момент совершения платежа.
            </p>
            <br />
            <b>
              <i>5. Способы оплаты товаров</i>
            </b>
            <br />
            <br />
            <p>
              <b>5.1.</b> Пользователь, являющийся юридическим лицом или
              индивидуальным предпринимателем, может осуществлять оплату товаров
              по Договору безналичным переводом денежных средств на основании
              выставленного счета. Компания вправе установить минимальный объем
              товаров, оплачиваемых данным способом. Допускается также оплата с
              использованием корпоративной банковской карты, оформленной на
              соответствующее юридическое лицо или индивидуального
              предпринимателя.
            </p>
            <br />
            <b>
              <i>6. Возврат денежных средств</i>
            </b>
            <br />
            <br />
            <p>
              <b>6.1.</b> После оплаты товара пользователь имеет право в течение
              24 часов вернуть денежные средства, написав в службу поддержки,
              контакты которой размещены на странице (раздел покупателям), с
              адреса электронной почты, указанной при регистрации либо оплате,
              письмо с просьбой сделать возврат, указав мотивированную причину
              отказа. Если подобной заявки в течении 24 часов после оплаты
              товара не поступило, Компания оставляет за собой право не
              возвращать оплаченную сумму.
            </p>
            <br />
            <p>
              <b>6.2.</b> Компания оставляет за собой право отказать в частичном
              возврате денежных средств без объяснения причин и рассматривает
              это в частном порядке по письменному заявлению от Пользователя.
            </p>
            <br />
            <p>
              <b>6.3.</b> Ответственность за получение любых документов (в том
              числе актов, сообщений, уведомлений) вышеуказанными способами
              лежит на Пользователе. Компания не несет ответственности за
              задержку или неполучение Пользователем документов, если это
              явилось результатом неисправности систем связи,
              действия/бездействия провайдеров, операторов связи, утраты
              Пользователем доступа к профилю или иных обстоятельств,
              находящихся вне зоны контроля Компании.
            </p>
            <br />
            <b>
              <i>7. Ответственность</i>
            </b>
            <br />
            <br />
            <p>
              <b>7.1.</b> Компания обязуется предпринимать все разумные усилия
              для надлежащего оказания Услуг, однако не отвечает и не
              компенсирует убытки пользователя в случае, если Пользователь не
              может воспользоваться Услугами по следующим причинам:
            </p>
            <br />
            <p>
              • технологические неисправности каналов связи общего пользования,
              посредством которых осуществляется доступ к товарам, утраты
              Пользователем доступа в интернет по любой причине, ошибки,
              пропуски, перерывы в работе или передаче данных, дефекты линий
              связи и иные технические сбои;
            </p>
            <br />
            <p>
              • несанкционированное вмешательство в работу третьих лиц, включая
              хакерские, DDoS-атаки, действия вирусных программ и иные нарушения
              работы;
            </p>
            <br />
            <p>• при наступлении обстоятельств непреодолимой силы;</p>
            <br />
            <p>
              <b>7.2.</b> В случае причинения убытков Пользователю по вине
              Компании ответственность определяется в порядке, предусмотренном
              законодательством РФ. При этом ответственность Компании перед
              Пользователями, использующими для предпринимательской и иной
              профессиональной деятельности, определяется в размере, не
              превышающем стоимость заказанной и оплаченной Пользователем, но не
              полученной по вине Компании.
            </p>
            <br />
            <p>
              <b>7.3.</b> Компания не отвечает перед Пользователем за убытки,
              возникшие у Пользователя не по вине Компании, в том числе в связи
              с нарушением Пользователем правил.
            </p>
            <br />
            <p>
              <b>7.4.</b> Компания не несет ответственности за перевод или
              поступление денежных средств Пользователя в оплату товаров.
              Безопасность, конфиденциальность, а также иные условия
              использования выбранных Пользователем способов оплаты определяются
              соглашениями между Пользователем и соответствующими организациями
              по приему платежей.
            </p>
            <br />
            <b>
              <i>8. Рассмотрение претензий</i>
            </b>
            <br />
            <br />
            <p>
              <b>8.1.</b> Отношения Сторон, вытекающие из настоящего Договора, а
              также тесно связанные с ними, регулируются действующим
              законодательством РФ.
            </p>
            <br />
            <p>
              <b>8.2.</b> Споры, возникшие в рамках настоящего Договора
              рассматриваются и разрешаются в арбитражном суде г. Челябинска.
            </p>
            <br />
            <p>
              <b>8.3.</b> До обращения в суд Пользователь с профилем
              юридического лица или индивидуального предпринимателя должен
              соблюсти внесудебный порядок разрешения споров, направив в адрес
              Компании письменную претензию, с приложением документов,
              подтверждающих обстоятельства и требования, на которые ссылается
              Пользователь. Срок рассмотрения таких претензий составляет не
              более 30 дней с момента получения претензии Компанией.
            </p>
            <br />
            <b>
              <i>9. Прочие условия</i>
            </b>
            <br />
            <br />
            <p>
              <b>9.1.</b> Договор вступает в силу с момента его заключения в
              порядке, указанном в разделе 2 Оферты, и действует в течение
              неопределенного срока до момента его прекращения в соответствии с
              Договором и законодательством.
            </p>
            <br />
            <p>
              <b>9.2.</b> Компания вправе изменять и/или дополнять Оферту в той
              мере, в какой это допускается законодательством, а также отозвать
              Оферту в любое время. Датой изменения Оферты является дата
              публикации на новой редакции Оферты. Вы должны ознакомиться с
              действующей редакцией Оферты, размещенной на, и с условиями каждой
              сделки до заключения Договора и совершения сделки.
            </p>
            <br />
            <p>
              <b>9.3.</b> Заказ товаров и совершение Пользователем сделки в
              рамках Договора после вступления в силу изменений в Оферте
              означает, что стороны пришли к согласию о внесении соответствующих
              изменений и/или дополнений в Договор. Такие изменения в Договоре
              не применяются к товарам, заказанным и оплаченным Пользователем до
              вступления в силу изменений в Оферте.
            </p>
          </TextSC>
        </ContainerSC>
      </ModalContainerSC>
      {createPortal(
        <ModalBackdoorSC onClick={handleClose("")} />,
        document.querySelector("#root") as HTMLElement,
      )}
    </>
  ) : null;
};

const {
  ContainerSC,
  ModalBackdoorSC,
  ModalContainerSC,
  ReplyIconSC,
  TextSC,
  TitleSC,
} = useRequisitesStyles();

export default React.memo(Requsites);
